import { render, staticRenderFns } from "./overflowdetailed.vue?vue&type=template&id=99abf6b8"
import script from "./overflowdetailed.vue?vue&type=script&lang=js"
export * from "./overflowdetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports